
import { of as observableOf,  Subject ,  Observable } from 'rxjs'

import { mergeMap,  catchError } from 'rxjs/operators'
import { useRef, useEffect } from 'react'
import Button from '@mui/material/Button'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import styles from './Statuses.pcss'
import { StoreThunkDispatch } from 'store/state'
import { message } from 'services/snackbar'
import { createStatusIdea } from 'services/content/statuses/actions'

export function CreateStatusIdeaPanel(props: { onCreated: () => void }) {
  const { onCreated } = props
  const dispatch = useDispatch<StoreThunkDispatch>()
  const textRef = useRef<HTMLTextAreaElement>(null)
  const tagsRef = useRef<HTMLInputElement>(null)

  const create$ = useRef<Subject<{ status: string, tags?: string[] }>>(undefined)

  useEffect(() => {
    create$.current = new Subject()
    create$.current.pipe(mergeMap((params: { status: string, tags?: string[] }) => {
      return dispatch(createStatusIdea(params.status, params.tags)).pipe(
        catchError((e: Error) => {
          dispatch(message(`An error occurred: ${e.message}`))
          return observableOf({ error: true })
        })
      )
    }))
      .subscribe((response: any) => {
        if (!response.error) {
          dispatch(message('Status added!'))
          onCreated()
        }
      })

    return () => create$.current?.unsubscribe()
  }, [dispatch, onCreated])

  const create = () => {
    const status = textRef.current?.value.trim()
    const tags = tagsRef.current?.value.split(',').map(value => value.trim()).filter(Boolean)

    if (status) {
      create$.current?.next({ status, tags })
      ; (textRef.current as any).value = ''
      ; (tagsRef.current as any).value = ''
    }
  }
  return (
    <section className={styles['box-create']}>
      <h3 className={styles['add-title']}>Add new</h3>
      <textarea className={styles.textarea} ref={textRef} placeholder="Enter text" rows={1} />
      <div className={styles['box-create-footer']}>
        <input type="text" placeholder="Tags (comma-separated)" ref={tagsRef} />
        <Button color="primary" variant="contained" size="small" onClick={create}>
          <FormattedMessage id="actions.save" />
        </Button>
      </div>
    </section>
  )
}
